// ©2024 Austin App House. All rights reserved.
import React from 'react';
import NearByCard from '../../layout/contractorCards/NearByCard';

const UserList = ({
  users,
  handler,
  profileInfo,
  blocked,
  invitedContractors,
  selectedContractors,
  handlerCheckbox,
  viewOnly,
}) => (
  <div className="nearby-user-list">
    <div className="nearby-user-list__head">
      <div className="font20 nearby-user-list__col">Contractor</div>
      <div className="font20 nearby-user-list__col nearby-user-list__col--stats">Work Performed</div>
      <div className="font20 nearby-user-list__col nearby-user-list__col--distance">Distance</div>
    </div>
    {
      users.map(user => (
        <NearByCard
          key={user._id}
          user={user}
          handler={handler}
          blocked={blocked}
          invitedContractors={invitedContractors}
          profileInfo={profileInfo}
          handlerCheckbox={handlerCheckbox}
          selectedContractors={selectedContractors}
          viewOnly={viewOnly}
        />
      ))
    }
  </div>
);

export default UserList;
